import {Uszkodzenie} from '../../../../../../../../shared/store/zbior-uszkodzen/zbiorUszkodzen';
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {StrategiaComponent} from './strategia.component';
import {SlownikUszkodzen} from '../../../../../../../../shared/model/uszkodzenia/slownik-uszkodzen';

@Component({
  templateUrl: './strategia-material-wymiary-wartosc.component.html'
})
export class StrategiaMaterialWymiaryWartoscComponent implements StrategiaComponent {

  language = window.navigator.language

  @Input()
  slownikUszkodzen!: SlownikUszkodzen;

  @Input()
  uszkodzenie!: Uszkodzenie<any>;

  @Output()
  public usunUszkodzenieClick = new EventEmitter<{identyfikatorUszkodzenia: string}>()

  usunUszkodzenie(event: {identyfikatorUszkodzenia: string}): void {
    this.usunUszkodzenieClick.emit(event)
  }

  getMaterialWykonczenia(uszkodzenie: Uszkodzenie<any>): string {
    const materialWykonczenia = uszkodzenie.elementyUszkodzone
      .find(elementUszkodzony => elementUszkodzony.rodzaj === 'materialWykonczenia')?.opis;
    return materialWykonczenia ? materialWykonczenia : '-';
  }
}
